import { render } from "./form_control.vue?vue&type=template&id=03c52398&scoped=true"
import script from "./form_control.vue?vue&type=script&lang=js"
export * from "./form_control.vue?vue&type=script&lang=js"

import "./form_control.vue?vue&type=style&index=0&id=03c52398&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c52398"]])

export default __exports__